import React, { Component } from 'react';

import {Header, Banner, Intro, Chapter, Features, Feature2, Counter, Author, Footer,
        LaborRegidora, SemaforoVotaciones, GestionResultados} from '../layouts/home01/index';
// Para activar la sección de videos: agregar `ResumenCabildo` a este import y descomentar <ResumenCabildo /> abajo.

class Home01 extends Component {
    render() {
        return (
            <div className="counter-scroll bg-home1 has-one-page">       
                <Header />       
                <Banner />
                <Intro />
                <Counter />
                <Chapter />
                <Features />
                <Feature2 />
                {/* Agregados: secciones nuevas */}
                <LaborRegidora />
                <SemaforoVotaciones />
                <GestionResultados />
                {/* TODO: activar cuando haya URLs de videos reales */}
                {/* <ResumenCabildo /> */}
                <Author />
                <Footer />
            </div>
        );
    }
}

export default Home01;
